import { Link } from "react-router-dom";
import { Button, Text, Heading } from "../../components";
import React from "react";

export default function ValuePropositionSection() {
  return (
    <>
      {/* value proposition section */}
      <div className="self-stretch">
        <div className="flex justify-center bg-gradient6 py-[94px] md:pb-5 md:pt-[60px] sm:py-[60px]">
          <div className="container-xs mb-1.5 flex justify-center px-14 md:px-5">
            <div className="flex w-full flex-col items-center gap-[52px] sm:gap-[26px]">
              <div className="mr-2.5 flex flex-col items-center gap-[18px] self-stretch md:mr-0">
                <Heading
                  as="h2"
                  className="text-[46px] font-bold text-color_style-01_neutrals-grey50 md:text-[42px] sm:text-[36px]"
                >
                  Value for our customers
                </Heading>
                <Text
                  size="text9xl"
                  as="p"
                  className="self-stretch text-center text-[24px] font-normal leading-[37px] text-color_style-02_primary_blue-blue100 md:text-[22px]"
                >
                  Zwilling Lab’s Unified Digital Twin platform, powered by Advanced AI & Engineering, provides valuable
                  insights and facilitates real-time monitoring leading to data-driven decisions and control over
                  production for manufacturing processes and equipment. This enables manufacturers to achieve lower
                  cost, higher quality and efficiency while ensuring compliance and sustainability.
                </Text>
              </div>
              <Button
                size="3xl"
                shape="round"
                className="min-w-[154px] rounded-[10px] px-6 font-bold tracking-[-0.60px] sm:px-5"
              >
                <Link
                  to="/contactus"
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  Get a Demo
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
